var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"supply-demand-category-item-mobile",class:_vm.on ? "on" : "",style:({color: (_vm.on ? "#EA4C1E" : '#858585')}),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.$t(_vm.info.title))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }